import React from 'react';
import { Button } from '@fluentui/react-components';
import { MarketingTile } from './MarketingTypes';
import { MarketingMarkdown } from './MarketingMarkdown';

interface Props {
  tiles: MarketingTile[];
  emptyMessage?: string;
}

const safeColor = (value: string): string => {
  if (/^#[0-9a-fA-F]{3,8}$/.test(value)) {
    return value;
  }
  return '#0f4c81';
};

export const MarketingGrid = ({ tiles, emptyMessage }: Props): JSX.Element => {
  if (!tiles || tiles.length === 0) {
    return (
      <div className="card marketing-empty">
        <p className="muted">{emptyMessage ?? 'No marketing tiles are available yet.'}</p>
      </div>
    );
  }

  const ordered = [...tiles].sort((a, b) => a.order - b.order || a.id - b.id);

  return (
    <div className="marketing-grid">
      {ordered.map((tile) => (
        <div key={tile.id} className="marketing-tile card">
          <div className="marketing-tile-header" style={{ background: safeColor(tile.color) }}>
            <h4>{tile.title || 'Untitled tile'}</h4>
          </div>
          <div className="marketing-tile-body">
            <MarketingMarkdown content={tile.content} />
          </div>
          {tile.link && (
            <div className="marketing-tile-footer">
              <Button
                as="a"
                appearance="primary"
                href={tile.link}
                target={tile.link.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
              >
                Explore
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
